var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "BlockTitle" } }, [
    _c("div", { staticClass: "block-title-container" }, [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.blockName,
            expression: "blockName",
          },
        ],
        attrs: { placeholder: _vm.$t("chatbotv2.typeBlockTitle") },
        domProps: { value: _vm.blockName },
        on: {
          input: function ($event) {
            if ($event.target.composing) {
              return
            }
            _vm.blockName = $event.target.value
          },
        },
      }),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }